
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/software-development",
      function () {
        return require("private-next-pages/services/software-development.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/software-development"])
      });
    }
  